/**
 * PinImages is meant to offer an accessible way to change the pin images for result pin
 * on the interactive map page. Given some config, an SVG should be customizable to
 * have branding consistent styling in this file.
 */
 class PinImages {
  /**
   * @param {Object} defaultPinConfig The configuration for the default pin
   * @param {Object} hoveredPinConfig The configuration for the hovered pin
   * @param {Object} selectedPinConfig The configuration for the selected pin
   */
  constructor(defaultPinConfig = {}, hoveredPinConfig = {}, selectedPinConfig = {}) {
    this.defaultPinConfig = defaultPinConfig;
    this.hoveredPinConfig = hoveredPinConfig;
    this.selectedPinConfig = selectedPinConfig;
  }

  /**
   * Generate standard theme pin given some parameters
   * @param {string} pin.backgroundColor Background color for the pin
   * @param {string} pin.strokeColor Stroke (border) color for the pin
   * @param {string} pin.labelColor Label (text) color for the pin
   * @param {number} pin.width The width of the pin
   * @param {number} pin.height The height of the pin
   * @param {string} pin.pinCount The index of the pin for the pin text
   * @return {Object} The SVG of the pin, and its width and height
   */
  generatePin ({
    backgroundColor = '#427ed2',
    strokeColor = '',
    labelColor = 'white',
    width = 20,
    height= 27,
    index = index,
    profile = ''
  } = {}) {
    const svg = `
    <svg width="${width}" height="${height}" viewBox="0 0 65 107" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_f_632_32289)">
        <ellipse cx="32.4982" cy="98.0207" rx="11.34" ry="6.3" fill="black" fill-opacity="0.12"/>
      </g>
      <mask id="path-2-outside-1_632_32289" maskUnits="userSpaceOnUse" x="0" y="0" width="65" height="98" fill="black">
        <rect fill="white" width="65" height="98"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M57.6506 51.4687C61.6363 46.1923 64 39.6222 64 32.5C64 15.103 49.897 1 32.5 1C15.103 1 1 15.103 1 32.5C1 39.6152 3.35904 46.1794 7.33766 51.4531C8.75401 53.4256 10.6707 55.5248 12.7929 57.849C20.1514 65.9081 29.9797 76.672 29.9797 94.2401C29.9797 95.6318 31.1079 96.7601 32.4997 96.7601V64H32.4997V96.7601C33.8915 96.7601 35.0197 95.6318 35.0197 94.2401C35.0197 76.672 44.848 65.9081 52.2066 57.849C54.3231 55.531 56.2353 53.4367 57.6506 51.4687Z"/>
      </mask>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M57.6506 51.4687C61.6363 46.1923 64 39.6222 64 32.5C64 15.103 49.897 1 32.5 1C15.103 1 1 15.103 1 32.5C1 39.6152 3.35904 46.1794 7.33766 51.4531C8.75401 53.4256 10.6707 55.5248 12.7929 57.849C20.1514 65.9081 29.9797 76.672 29.9797 94.2401C29.9797 95.6318 31.1079 96.7601 32.4997 96.7601V64H32.4997V96.7601C33.8915 96.7601 35.0197 95.6318 35.0197 94.2401C35.0197 76.672 44.848 65.9081 52.2066 57.849C54.3231 55.531 56.2353 53.4367 57.6506 51.4687Z" fill="${backgroundColor}"/>
      <path d="M57.6506 51.4687L56.8526 50.8659L56.8456 50.8753L56.8387 50.8848L57.6506 51.4687ZM7.33766 51.4531L8.14995 50.8698L8.14307 50.8603L8.13596 50.8508L7.33766 51.4531ZM12.7929 57.849L13.5313 57.1747L12.7929 57.849ZM32.4997 96.7601V97.7601H33.4997V96.7601H32.4997ZM32.4997 64V63H31.4997V64H32.4997ZM32.4997 64H33.4997V63H32.4997V64ZM32.4997 96.7601H31.4997V97.7601H32.4997V96.7601ZM52.2066 57.849L51.4681 57.1747L52.2066 57.849ZM58.4485 52.0714C62.5608 46.6275 65 39.8471 65 32.5H63C63 39.3972 60.7118 45.7571 56.8526 50.8659L58.4485 52.0714ZM65 32.5C65 14.5507 50.4493 0 32.5 0V2C49.3447 2 63 15.6553 63 32.5H65ZM32.5 0C14.5507 0 0 14.5507 0 32.5H2C2 15.6553 15.6553 2 32.5 2V0ZM0 32.5C0 39.8399 2.43438 46.6141 6.53935 52.0553L8.13596 50.8508C4.28371 45.7446 2 39.3904 2 32.5H0ZM6.52536 52.0363C7.98312 54.0666 9.94449 56.2125 12.0544 58.5233L13.5313 57.1747C11.397 54.8372 9.52489 52.7847 8.14995 50.8698L6.52536 52.0363ZM12.0544 58.5233C19.4171 66.5869 28.9797 77.094 28.9797 94.2401H30.9797C30.9797 76.2499 20.8858 65.2293 13.5313 57.1747L12.0544 58.5233ZM28.9797 94.2401C28.9797 96.1841 30.5556 97.7601 32.4997 97.7601V95.7601C31.6602 95.7601 30.9797 95.0795 30.9797 94.2401H28.9797ZM33.4997 96.7601V64H31.4997V96.7601H33.4997ZM32.4997 65H32.4997V63H32.4997V65ZM31.4997 64V96.7601H33.4997V64H31.4997ZM32.4997 97.7601C34.4438 97.7601 36.0197 96.1841 36.0197 94.2401H34.0197C34.0197 95.0795 33.3392 95.7601 32.4997 95.7601V97.7601ZM36.0197 94.2401C36.0197 77.094 45.5824 66.5869 52.945 58.5233L51.4681 57.1747C44.1137 65.2293 34.0197 76.2499 34.0197 94.2401H36.0197ZM52.945 58.5233C55.0494 56.2185 57.006 54.0778 58.4625 52.0525L56.8387 50.8848C55.4647 52.7956 53.5968 54.8434 51.4681 57.1747L52.945 58.5233Z" fill="url(#paint0_linear_632_32289)" mask="url(#path-2-outside-1_632_32289)"/>
      <circle cx="32.5" cy="29.5" r="14.5" fill="#C9E0F0"/>
      <path d="M26 38V36H31V34C29.6167 34 28.4375 33.5125 27.4625 32.5375C26.4875 31.5625 26 30.3833 26 29C26 27.9833 26.2792 27.0583 26.8375 26.225C27.3958 25.3917 28.15 24.7833 29.1 24.4C29.2333 23.8333 29.5292 23.375 29.9875 23.025C30.4458 22.675 30.9667 22.5 31.55 22.5L31 20.95L31.95 20.6L31.6 19.7L33.5 19L33.8 19.95L34.75 19.6L37.5 27.1L36.55 27.45L36.9 28.4L35 29.1L34.7 28.15L33.75 28.5L33.15 26.85C32.9 27.0833 32.6125 27.2583 32.2875 27.375C31.9625 27.4917 31.6333 27.5333 31.3 27.5C30.9333 27.4667 30.5917 27.3542 30.275 27.1625C29.9583 26.9708 29.6833 26.7333 29.45 26.45C29 26.7167 28.6458 27.075 28.3875 27.525C28.1292 27.975 28 28.4667 28 29C28 29.8333 28.2917 30.5417 28.875 31.125C29.4583 31.7083 30.1667 32 31 32H39V34H34V36H40V38H26ZM34.65 26.55L35.55 26.2L33.85 21.5L32.9 21.85L34.65 26.55ZM31.5 26C31.7833 26 32.0208 25.9042 32.2125 25.7125C32.4042 25.5208 32.5 25.2833 32.5 25C32.5 24.7167 32.4042 24.4792 32.2125 24.2875C32.0208 24.0958 31.7833 24 31.5 24C31.2167 24 30.9792 24.0958 30.7875 24.2875C30.5958 24.4792 30.5 24.7167 30.5 25C30.5 25.2833 30.5958 25.5208 30.7875 25.7125C30.9792 25.9042 31.2167 26 31.5 26Z" fill="${backgroundColor}"/>
      <defs>
      <filter id="filter0_f_632_32289" x="19.1582" y="89.7207" width="26.6797" height="16.5996" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_632_32289"/>
      </filter>
      <linearGradient id="paint0_linear_632_32289" x1="32.5" y1="1" x2="32.5" y2="96.7601" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0.35"/>
      </linearGradient>
      </defs>
    </svg>
    `;
    return { svg, width, height };
  };

  /**
   * Get the default pin image
   * @param {Number} pinCount The pin index number for the pin label
   * @param {Object} profile The profile data for the entity associated with the pin
   */
  getDefaultPin (index, profile) {
    return this.generatePin({
      backgroundColor: this.defaultPinConfig.backgroundColor,
      strokeColor: this.defaultPinConfig.strokeColor,
      labelColor: this.defaultPinConfig.labelColor,
      width: 55,
      height: 100,
      index: index,
      profile: profile
    });
  }

  /**
   * Get the hovered pin image
   * @param {Number} pinCount The pin index number for the pin label
   * @param {Object} profile The profile data for the entity associated with the pin
   */
  getHoveredPin (index, profile) {
    return this.generatePin({
      backgroundColor: this.hoveredPinConfig.backgroundColor,
      strokeColor: this.hoveredPinConfig.strokeColor,
      labelColor: this.hoveredPinConfig.labelColor,
      width: 55,
      height: 100,
      index: index,
      profile: profile
    });
  }

  /**
   * Get the selected pin image
   * @param {Number} pinCount The pin index number for the pin label
   * @param {Object} profile The profile data for the entity associated with the pin
   */
  getSelectedPin (index, profile) {
    return this.generatePin({
      backgroundColor: this.selectedPinConfig.backgroundColor,
      strokeColor: this.selectedPinConfig.strokeColor,
      labelColor: this.selectedPinConfig.labelColor,
      width: 55,
      height: 100,
      index: index,
      profile: profile
    });
  }
}

export { PinImages };